/**
 * Collection Filters - Filter products by collection and sort by metafield
 */
class CollectionFilters {
  // Static property to track active filter across reinitializations
  static activeFilter = 'all';
  static initialized = false;

  constructor() {
    this.filterButtons = document.querySelectorAll('.collection-filter-btn');
    this.productGrid = document.getElementById('product-grid');
    this.filterSection = document.querySelector('.collection-filter-section');
    this.hoverLabel = document.getElementById('collection-filter-hover-label');
    this.products = this.productGrid ? Array.from(this.productGrid.querySelectorAll('li.column[data-collections]')) : [];
    this.currentFilter = CollectionFilters.activeFilter;
    
    this.init();
  }

  init() {
    if (!this.productGrid) {
      return;
    }

    // Sort products by metafield on page load
    this.sortByMetafield();

    // Apply current filter to all products (including newly loaded ones)
    if (this.currentFilter !== 'all') {
      this.filterByCollection(this.currentFilter);
    }

    if (!this.filterButtons.length) {
      return;
    }

    // Only attach event listeners once
    if (!CollectionFilters.initialized) {
      CollectionFilters.initialized = true;
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    this.filterButtons.forEach(btn => {
      // Hover events for label
      btn.addEventListener('mouseenter', () => {
        const label = btn.dataset.label;
        if (this.hoverLabel && label) {
          this.hoverLabel.textContent = label;
          this.hoverLabel.classList.add('visible');
        }
      });

      btn.addEventListener('mouseleave', () => {
        if (this.hoverLabel) {
          this.hoverLabel.classList.remove('visible');
        }
      });

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const collection = btn.dataset.collection;
        
        // Store scroll position before filtering
        const scrollPos = window.scrollY;
        
        // Get fresh reference to products
        const productGrid = document.getElementById('product-grid');
        const products = productGrid ? Array.from(productGrid.querySelectorAll('li.column[data-collections]')) : [];
        
        // If clicking the already active filter, deselect it (show all)
        if (btn.classList.contains('active')) {
          CollectionFilters.activeFilter = 'all';
          this.filterProductsByCollection(products, 'all');
          btn.classList.remove('active');
        } else {
          CollectionFilters.activeFilter = collection;
          this.filterProductsByCollection(products, collection);
          this.updateActiveButton(btn);
        }
        
        // Restore scroll position to prevent jumping
        window.scrollTo(0, scrollPos);
      });
    });
  }

  filterProductsByCollection(products, collectionHandle) {
    products.forEach(product => {
      const productCollections = product.dataset.collections ? product.dataset.collections.split(',') : [];

      if (collectionHandle === 'all') {
        product.style.display = '';
        product.classList.remove('hidden');
      } else if (productCollections.includes(collectionHandle)) {
        product.style.display = '';
        product.classList.remove('hidden');
      } else {
        product.style.display = 'none';
        product.classList.add('hidden');
      }
    });
  }

  sortByMetafield() {
    if (!this.productGrid || !this.products.length) return;

    // Only sort visible products
    const visibleProducts = this.products.filter(p => p.style.display !== 'none');

    const sortedProducts = [...visibleProducts].sort((a, b) => {
      const orderA = parseInt(a.dataset.sortOrder) || 9999;
      const orderB = parseInt(b.dataset.sortOrder) || 9999;
      return orderA - orderB;
    });

    // Reorder visible products in DOM
    sortedProducts.forEach(product => {
      this.productGrid.appendChild(product);
    });
  }

  filterByCollection(collectionHandle) {
    CollectionFilters.activeFilter = collectionHandle;
    this.currentFilter = collectionHandle;
    this.filterProductsByCollection(this.products, collectionHandle);

    // Re-sort after filtering
    this.sortByMetafield();
  }

  updateActiveButton(activeBtn) {
    this.filterButtons.forEach(btn => btn.classList.remove('active'));
    activeBtn.classList.add('active');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CollectionFilters());
} else {
  new CollectionFilters();
}
